export const MODIFY_API_MENU_ITEM = 'MODIFY_API_MENU_ITEM';

export function modifyAPIMenuItem(apiMenuItem){
    return{
        type: MODIFY_API_MENU_ITEM,
        mainState: {
            apiMenuItem: apiMenuItem
        }
    }
}